import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ModalPopup from '../components/common/ModalPopup';
import Style from './SocIntegration.module.css';
import socApisCA from '../components/data/socApisCA.json'
import SocDetails from './SocDetails';
import SOCHeader from './SOCHeader';
class ThreatIntelSOC extends Component {

    constructor(props) {
        super(props);
        this.state = {
            socApis: socApisCA.filter(option => option.tabName === "Threat Intelligence"),
            selectedApi: socApisCA.filter(option => option.tabName === "Threat Intelligence")[0].tabName
        };
    }

    componentDidMount = () => {
        if (this.props.selectedCustomer) {
            this.setjson();
        } 
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.selectedCustomer !== prevProps.selectedCustomer) {
            this.setjson();
        }
    }

    fetchExpiryDateDetails = () => {
        const { apiKeyExpiryDate, tenantApiKeyExpiryDate } = this.props;
        var expiryDate = apiKeyExpiryDate ? new Date(apiKeyExpiryDate) : null;
        var expiryDateString = expiryDate ? expiryDate.toISOString().split('T')[0] : null;
        var tenantApiExpiry = tenantApiKeyExpiryDate ? new Date(tenantApiKeyExpiryDate) : null;
        var tenantApiExpiryDateString = tenantApiExpiry ? tenantApiExpiry.toISOString().split('T')[0] : null;

        return { expiryDateString, tenantApiExpiryDateString };
    }

    handleClick = (tab) => {
        this.setState({
          selectedApi: tab,
        })
    }

    fetchCurrentDateDetails = () =>{
        var priorDate = new Date();
        priorDate.setDate(priorDate.getDate() - 30);
        var priorDateString = priorDate.toISOString().split('T')[0];
        var today = new Date();
        var todayString = today.toISOString().split('T')[0];
        return { priorDateString, todayString };
    }

    setjson = () =>{
        let filteredApis = socApisCA.filter(option => option.tabName === "Threat Intelligence");
        let jsonString = JSON.stringify(filteredApis);
        let { priorDateString, todayString } = this.fetchCurrentDateDetails();
        const baseUrl = process.env.REACT_APP_API_BASE_URL;

        // Replace certain values
        jsonString = jsonString.replaceAll('{priorDateString}', priorDateString); 
        jsonString = jsonString.replaceAll('{todayString}', todayString); 
        jsonString = jsonString.replaceAll('{baseUrl}', baseUrl); 


        // Convert back to JSON object
        const modifiedJSON = JSON.parse(jsonString);
        this.setState({
            socApis: modifiedJSON,
            selectedApi: modifiedJSON[0].tabName
          })
    }




    render() {
        if (!this.props.selectedCustomer)
            return null;

        return (
            <div  className={`Container`}
              style={{
                padding: '0 1.8% 0 2.4%',
                margin: '0 0 0 43px',
              }}>
                <SOCHeader 
                    title="Threat Intelligence"
                    description={
                        <>
                        Welcome to <b>PIXM Threat Intelligence</b>. The above API key is your organization's private key and should not be shared with anyone outside your organization.<br/>
                        Your API key allows you to fetch your Threat Intelligence data in JSON format using the SOC API.<br/>
                        </>
                    }
                    showGlobalKey={false}
                    showCustomerKey={true}
                />

                <div className="mt-4 mb-2">
                    { (this.state.socApis.length === 1 && this.state.socApis[0].tabName === "Threat Intelligence") ? 
                    null 
                    : 
                    (<div className={`${Style.navbar} ${Style.boxShadow} d-flex pl-4`}>
                        { this.state.socApis
                            .map((socApi, index)=>
                            <div 
                                key={socApi.tabId}
                                onClick={() => this.handleClick(socApi.tabName)}
                                className={`${
                                this.state.selectedApi === socApi.tabName
                                    ? `${Style.navbarSelectedItemStyle} d-flex align-items-center`
                                    : `${Style.navbarFontStyle} d-flex align-items-center`
                                }`}
                                style={{ marginRight: '20px', fontSize: '14px' }}
                            >
                                {socApi.tabName}
                            </div>)
                            }
                    </div>)}
                </div>
                
                <SocDetails apiData={this.state.socApis.filter((socApi)=>socApi.tabName === this.state.selectedApi)[0]}/>

                {this.props.userMsg && <ModalPopup statusCode={this.props.statusCode} msg={this.props.userMsg} />}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    loading: state.entities.customers.loading,
    apiKey: state.entities.customers.apiKey,
    selectedCustomer: state.entities.customers.selected,
    tokenRoles: state.entities.user.roles,
    licenseType: state.entities.customers.selected?.licenseType,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
})

const mapDispatchToProps = (dispatch) => ({
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThreatIntelSOC))